import { bus } from "@/main";
import { getMenuEntry } from "@/data/models/menu.model";

export default {
	data() {
		return{
		
		}
	},
	props: [
		"content",
		"alternative"
	],
	methods: {}
}



// WEBPACK FOOTER //
// ./src/components/blocks/text-block/text.block.js